import moment, { type MomentInput } from 'moment'
import { localDateString } from '@/utils/localDate'

/**
 * Emission date proposed when validating an invoice: today while it is after the last invoice
 * of the accounting diary and within its period (last day included), otherwise the last
 * invoice date. Compared by local calendar day, the API sending both dates as `YYYY-MM-DD`.
 */
export function defaultEmissionDate(
  accountingDiary: { to: string; last_invoice_date?: string | null },
  now: MomentInput = moment()
): string {
  const today = moment(now)
  const lastInvoiceDate = accountingDiary.last_invoice_date

  const isAfterLastInvoice =
    !lastInvoiceDate || today.isAfter(moment(lastInvoiceDate), 'day')
  const isWithinDiaryPeriod = today.isSameOrBefore(
    moment(accountingDiary.to),
    'day'
  )

  if (isAfterLastInvoice && isWithinDiaryPeriod) {
    return localDateString(today)
  }

  return lastInvoiceDate ?? localDateString(today)
}
